import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  "data-bs-toggle": "modal",
  "data-bs-target": "#create",
  class: "btn btn-success me-4",
  name: "create brand"
}, " Create ", -1)
const _hoisted_7 = {
  ref: "modalRef",
  class: "modal fade",
  id: "create",
  tabindex: "-1",
  "aria-labelledby": "create",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header fs-3" }, "Create New Sub Model", -1)
const _hoisted_11 = { class: "modal-body px-12" }
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CardTable = _resolveComponent("CardTable")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CardTable, {
      ref: "tableRef",
      "is-delete": false,
      name: "Car Sub Model",
      header: $setup.tableHeader,
      endpoint: "car-brand-series",
      modelValue: $setup.tableData,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.tableData) = $event)),
      loadingProp: $setup.loading,
      breadcrumbs: $setup.breadcrumbs,
      currentIndex: $setup.currentIndex,
      onChangeIndex: _cache[1] || (_cache[1] = (index) => ($setup.currentIndex = index)),
      filterData: $setup.filterData
    }, {
      "cell-no": _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(row.no), 1)
      ]),
      "cell-name": _withCtx(({ row, index }) => [
        ($setup.currentIndex !== index)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(row.name), 1))
          : _createCommentVNode("", true),
        ($setup.currentIndex === index)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "like-el-input w-150px",
                "onUpdate:modelValue": ($event: any) => ((row.name) = $event)
              }, null, 8, _hoisted_3), [
                [_vModelText, row.name]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      "cell-model": _withCtx(({ row, index }) => [
        ($setup.currentIndex !== index)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.models.find((model) => model.id === row.model)?.name +
          ` (${$setup.models.find((model) => model.id === row.model)?.type?.name})`), 1))
          : _createCommentVNode("", true),
        ($setup.currentIndex === index)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_select, {
                class: "w-150px",
                filterable: "",
                modelValue: row.model,
                "onUpdate:modelValue": ($event: any) => ((row.model) = $event)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.models, (model) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: model.name + ` (${model.type.name})`,
                      key: model.id,
                      value: model.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      create: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["header", "modelValue", "loadingProp", "breadcrumbs", "currentIndex", "filterData"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
            }, [
              _createVNode(_component_el_input, {
                type: "text",
                class: "mb-3",
                placeholder: "Sub Model",
                modelValue: $setup.inputRef.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.inputRef.name) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_select, {
                class: "w-100 mb-3",
                modelValue: $setup.inputRef.model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.inputRef.model) = $event)),
                filterable: "",
                placeholder: "Select Model"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.models, (model) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: model.name,
                      key: model.id,
                      value: model.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.create())),
                  class: "btn btn-primary"
                }, "Confirm")
              ])
            ], 40, _hoisted_12)
          ])
        ])
      ])
    ], 512)
  ], 64))
}